import React from 'react';
import { Link } from "react-router-dom";
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import { GameData } from "../share/game-data.js"
import TechnologyCostFormulas from "../share/formulas/technology-cost-formulas.js"
import * as ICONS from "../other/icons.js";

// The research menu: shows technologies and allows to research new ones
class ResearchView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {
            research: null,
            outstanding_request: false,
        };
    }

    refreshState() {
        Backend.getPlayerResearchDetails((res) => {
            this.setState({ research: res.research });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let research = this.state.research;
        if (research.researcher_count === 0) {
            return <div>Need to build at least one research lab first.</div>
        }

        return (
            <div>
                <h1>Research</h1>
                <ActiveResearchProject research={research}
                    onCancelResearch={(eventId) => this.onCancelResearch(eventId)} />
                <TechnologiesTable technologies={research.technologies}
                    research_queue={research.research_queue}
                    researcherCount={research.researcher_count}
                    outstandingRequest={this.state.outstanding_request}
                    onStartResearch={(technology) => this.onStartResearch(technology)} />
                <util.JsonDebug obj={research} />
            </div>
        );
    }

    onStartResearch(technology) {
        // Disable buttons while request is in-flight
        if (this.state.outstanding_request) {
            return;
        }
        this.setState({ outstanding_request: true });

        // Send request
        Backend.tryStartResearch(technology.id, (res) => {
            if (res.success) {
                this.setState({
                    outstanding_request: false,
                    research: res.research,
                });
            } else {
                alert(res.error);
                this.setState({
                    outstanding_request: false,
                });
            }
        });
    }

    onCancelResearch(eventId) {
        if (this.state.outstanding_request) {
            return;
        }
        this.setState({ outstanding_request: true });

        Backend.tryCancelResearch(eventId, (res) => {
            if (res.success) {
                this.setState({
                    outstanding_request: false,
                    research: res.research,
                });
            } else {
                alert(res.error);
                this.setState({
                    outstanding_request: false,
                });
            }
        });
    }
}

class ActiveResearchProject extends React.Component {
    render() {
        let research = this.props.research;

        return (
            <div style={{ display: "flex" }}>
                <div style={{ flex: "50%" }}>
                    <img src={ICONS.PAGES.research_lab} alt={"A nice research lab icon, to get you in the mood."}
                        style={{ height: 300 }} />
                </div>
                <div style={{ flex: "50%" }}>
                    <p>
                        {GameData.BUILDING_BY_ID.lab.description}
                    </p>
                    <p>
                        Number of active scientists: {research.researcher_count}
                    </p>
                    {this.renderResearchQueue(research.research_queue)}
                </div>
            </div>);
    }

    renderResearchQueue(queue) {
        if (queue == null || queue.length === 0) {
            return <pre>No active research project.</pre>;
        }

        return (
            <table className="generic-list">
                <thead>
                <tr>
                    <td>Research</td>
                    <td>Level</td>
                    <td>Duration</td>
                    <td />
                </tr>
                </thead>
                <tbody>
                {queue.map((item) => {
                    const tech = GameData.TECHNOLOGY_BY_ID[item.technology_id];
                    return (<tr key={item.event_id}>
                        <td style={{width: "40%"}}>
                            {tech ? tech.ui_name : item.technology_id}
                        </td>
                        <td>
                            Level: {item.level}
                        </td>
                        <td style={{width: "20%", paddingRight: "12px"}}>
                            <util.Timer date={item.finished}/>
                        </td>
                        <td>
                            <div className="action-button"
                                 onClick={() => this.props.onCancelResearch(item.event_id)}>
                                Cancel
                            </div>
                        </td>
                    </tr>);
                })}
                </tbody>
            </table>
        );
    }
}

class TechnologiesTable extends React.Component {
    render() {
        let technologies = this.props.technologies;
        let researcher_count = this.props.researcherCount;

        return (
            <div>
                <table className="resources">
                    <thead>
                        <tr>
                            <td />
                            <td>
                                <div>Technology</div>
                            </td>
                            <td>
                                <div>Costs</div>
                            </td>
                            <td>
                                <div>Time</div>
                            </td>
                            <td />
                        </tr>
                    </thead>
                    <tbody>
                        {GameData.TECHNOLOGIES.map((technology, idx) => {
                            return (<SingleTechnology key={idx}
                                outstandingRequest={this.props.outstandingRequest}
                                researchQueue={this.props.research_queue}
                                technologyId={technology.id}
                                level={technologies[technology.id]}
                                updatedLevel={technologies[technology.id]} // TODO
                                researcherCount={researcher_count}
                                onStartResearch={() => this.props.onStartResearch(technology)} />);
                        })}
                    </tbody>
                </table>
            </div>)
    }
}

class SingleTechnology extends React.Component {
    render() {
        let technology_id = this.props.technologyId;
        let level = this.props.level;
        let updated_level = this.props.updatedLevel;
        let researcher_count = this.props.researcherCount;
        if (level == null) {
            return null;
        }

        let has_outstanding_request = this.props.outstandingRequest;
        let is_already_queued = (this.props.researchQueue || []).some(
            item => item.technology_id === technology_id
        );

        let can_research = !has_outstanding_request && !is_already_queued;
        let cost = TechnologyCostFormulas.getCostForIncrement(GameData.TECHNOLOGY_BY_ID[technology_id], level + 1);
        let time = TechnologyCostFormulas.getTimeForIncrement(GameData.TECHNOLOGY_BY_ID[technology_id], level + 1, researcher_count);

        let is_complete = level >= GameData.TECHNOLOGY_BY_ID[technology_id].max_level;
        let has_resources = cost <= util.getGPS().money;

        return (
            <tr>
                <td style={{ width: "60px", padding: "0px" }}>
                    <img src={ICONS.TECHNOLOGIES[technology_id]} alt={GameData.techName(technology_id)} style={{ width: "100%", marginBottom: "-4px" }} />
                </td>
                <td style={{ paddingLeft: "12px" }}>
                    <Link className="link-button" to={{ pathname: "/game/technology-info/" + technology_id }}>{GameData.techName(technology_id)}</Link>
                    <div><span className="boring-info-text">level</span> {level}{level !== updated_level ? <span style={{ color: "yellow" }}> + {(updated_level - level)}</span> : null}</div>
                </td>
                <td style={{ textAlign: "right" }}>
                    {is_complete ? null : (<util.MoneyWithIcon bad={!has_resources} amount={cost} />)}
                </td>
                <td style={{ textAlign: "right" }}>
                    {is_complete ? null : (<util.TimeSpan timeSpan={time} />)}
                </td>
                <td>
                    <StartResearchButton hasResources={has_resources} isComplete={is_complete}
                        canResearch={can_research} isAlreadyQueued={is_already_queued}
                        onStartResearch={() => this.props.onStartResearch()} />
                </td>
            </tr>
        );
    }
}

class StartResearchButton extends React.Component {
    render() {
        if (this.props.isComplete) {
            return (<div>fully researched</div>);
        }
        if (!this.props.hasResources) {
            return (<div>not enough money</div>);
        }
        if (this.props.isAlreadyQueued) {
            return (<div className="action-button-inactive">Queued</div>);
        }

        if (this.props.canResearch) {
            return (<div className="action-button" onClick={() => this.props.onStartResearch()}>Research</div>)
        } else {
            return (<div className="action-button-inactive">Research</div>)
        }
    }
}

export default util.withNavigation(ResearchView);
